import React from "react";
import PropTypes from "prop-types";

export default function AdminRoleInfo({ hasSuperAdmin }) {
    return (
        <div className="nav-description" name="description">
            <strong>{hasSuperAdmin ? "Super Admin" : "Experian Admin"}</strong>
        </div>
    );
}

// Mark safe for LocalNavMenu structural expansion (must remain hook-free)
AdminRoleInfo.__localNavSection = true;

AdminRoleInfo.propTypes = {
    hasSuperAdmin: PropTypes.bool.isRequired,
};
